import { render } from "./App.vue?vue&type=template&id=30137f26&scoped=true&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=30137f26&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/atomic-design/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30137f26"]])

export default __exports__